import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://www.millenniumrealtysf.com/api',
});

const clearAdminSession = () => {
  localStorage.removeItem('millennium_admin_token');
  if (window.location.pathname.startsWith('/admin')) {
    window.location.href = '/admin/login';
  }
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('millennium_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAdminSession();
    }
    return Promise.reject(error);
  }
);

export const getListings = async (params = {}) => {
  const { data } = await api.get('/listings', { params });
  return data;
};

export const getListingBySlug = async (slug, type) => {
  const { data } = await api.get(`/listings/${slug}`, { params: type ? { type } : undefined });
  return data.listing;
};

export const adminLogin = async (email, password) => {
  const { data } = await api.post('/auth/login', { email, password });
  return data;
};

export const getAdminListings = async (params = {}) => {
  const { data } = await api.get('/admin/listings', { params });
  return data;
};

export const getAdminListingsByType = async (type, params = {}) => {
  const { data } = await api.get('/admin/listings', { params: { type, ...params } });
  return data;
};

export const createListing = async (formData) => {
  const { data } = await api.post('/admin/listings', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.listing;
};

export const updateListing = async (id, formData) => {
  const { data } = await api.put(`/admin/listings/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.listing;
};

export const deleteListing = async (id) => {
  await api.delete(`/admin/listings/${id}`);
};

export const updateListingStatus = async (id, status) => {
  const { data } = await api.patch(`/admin/listings/${id}/publish`, { status });
  return data.listing;
};

export const changeAdminPassword = async (currentPassword, newPassword) => {
  const { data } = await api.patch('/admin/change-password', { currentPassword, newPassword });
  return data;
};

export default api;
